import { c as _c } from "react/compiler-runtime";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useRefreshSeatUsage } from "@components/table/members/assign-seats/use-refresh-seat-usage";
import { setMemberPermissionsInCompany } from "@store/members/members-slice-thunk";
import { useAppDispatch } from "@store/store-helper";
/** Returns how to give a member a SCENE seat or take it away again, and how to give a Sphere XG seat */
export function useSceneSeatPermission() {
  const $ = _c(10);
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  const refreshSeatUsage = useRefreshSeatUsage();
  let t0;
  if ($[0] !== companyId || $[1] !== dispatch) {
    t0 = async function setSceneSeatPermission(member, isAllowed) {
      await dispatch(setMemberPermissionsInCompany({
        companyId,
        userIdentity: member.identity,
        permissions: [{
          name: "sceneSeat",
          allowed: isAllowed
        }]
      })).unwrap();
    };
    $[0] = companyId;
    $[1] = dispatch;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const setSceneSeatPermission = t0;
  let t1;
  if ($[3] !== companyId || $[4] !== dispatch) {
    t1 = async function setXgSeatPermission(member_0) {
      await dispatch(setMemberPermissionsInCompany({
        companyId,
        userIdentity: member_0.identity,
        permissions: [{
          name: "activeSeat",
          allowed: true
        }]
      })).unwrap();
    };
    $[3] = companyId;
    $[4] = dispatch;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const setXgSeatPermission = t1;
  let t2;
  if ($[6] !== refreshSeatUsage || $[7] !== setSceneSeatPermission || $[8] !== setXgSeatPermission) {
    t2 = {
      setSceneSeatPermission,
      setXgSeatPermission,
      refreshSeatUsage
    };
    $[6] = refreshSeatUsage;
    $[7] = setSceneSeatPermission;
    $[8] = setXgSeatPermission;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}